import { Pipe, PipeTransform, inject } from "@angular/core";

import { CurrencyService } from "@services";

@Pipe({ standalone: true, name: "mnRound" })
export class RoundPipe implements PipeTransform {
  private readonly crS = inject(CurrencyService);

  public transform(value?: string | number, fallback?: string, odds?: boolean): string {
    return this.crS.round({ value: typeof value === "number" ? `${value}` : value, fallback, odds });
  }
}
